/* ============================================================
   wofr.js  -  Love Your Dog Club page (#wofr)
   Theme asset, loaded with defer. Paired with wofr.css.
   Exits quietly if #wofr is not on the page.
   ============================================================ */
(function(){
  'use strict';
  var root = document.getElementById('wofr');
  if(!root) return;

  var $ = function(s){ return root.querySelector(s); };
  var elBal=$('[data-wofr-bal]'), elNum=$('[data-wofr-num]'), elTier=$('[data-wofr-tier]'),
      elJoin=$('[data-wofr-join]'), elGrid=$('[data-wofr-grid]'), elNudge=$('[data-wofr-nudge]'),
      elDead=$('[data-wofr-dead]'), elDbg=$('[data-wofr-dbg]'), elSince=$('[data-wofr-since]'),
      elNext=$('[data-wofr-next]'), elNextPic=$('[data-wofr-next-pic]'),
      elNextK=$('[data-wofr-next-k]'), elNextN=$('[data-wofr-next-n]'), elNextM=$('[data-wofr-next-m]'),
      elOff=$('[data-wofr-off]'), elRail=$('[data-wofr-rail]'), elFill=$('[data-wofr-fill]'),
      elPin=$('[data-wofr-pin]'), elPinNum=$('[data-wofr-pinnum]'), elTicks=$('[data-wofr-ticks]'),
      elMeter=$('[data-wofr-meter]'), elMFill=$('[data-wofr-mfill]'), elMCap=$('[data-wofr-mcap]');

  var INSIDER_AT = parseInt(root.getAttribute('data-insider-at'), 10) || 0;
  var balance = null;          // null until we genuinely read a number
  var REDEEM = '#smile-points-products';

  /* Diagnostic trail. Read window.WOFR in the console to see exactly which
     branch ran. Costs nothing and makes a blank shelf answerable in one line. */
  var WOFR = window.WOFR = { steps:[], smile:false, customer:false, ladder:0, error:null };
  function log(s){ WOFR.steps.push(s); paint(); }

  /* Add ?wofrdebug=1 to the URL to see the trail on the page itself. */
  var DEBUG = /[?&]wofrdebug=1/.test(location.search);
  function fontReport(){
    try {
      var cs = getComputedStyle(root);
      var mine = root.querySelector('.wofr-h2');
      var theirs = document.querySelector('h1,h2,h3');
      var out = [];
      out.push('--font-heading-family = ' + (cs.getPropertyValue('--font-heading-family').trim() || '(not defined)'));
      out.push('--wofr-display resolved = ' + (cs.getPropertyValue('--wofr-display').trim() || '(empty)'));
      if(mine)   out.push('my heading renders as  = ' + getComputedStyle(mine).fontFamily);
      if(theirs) out.push('theme heading renders  = ' + getComputedStyle(theirs).fontFamily);
      out.push('body renders as        = ' + getComputedStyle(document.body).fontFamily);
      return out.join('\n');
    } catch(e){ return 'font report failed: ' + e; }
  }

  function paint(){
    if(!DEBUG || !elDbg) return;
    elDbg.hidden = false;
    elDbg.textContent =
      'smile=' + WOFR.smile + '  customer=' + WOFR.customer +
      '  ladder=' + WOFR.ladder + '  error=' + WOFR.error + '\n\n' +
      WOFR.steps.map(function(x,i){ return (i+1) + '. ' + x; }).join('\n') +
      '\n\n--- FONTS ---\n' + fontReport();
  }

  /* The shelf must never be left shimmering at someone. */
  function shelfDead(why){
    log('shelf empty: ' + why);
    elGrid.innerHTML = '';
    if(elDead) elDead.hidden = false;
    realign();                 // clearing the skeletons also moves everything below
  }

  log('script ran, canary=' + (window.WOFR_CANARY ? 'yes' : 'no'));

  function esc(s){
    return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];
    });
  }
  function commas(n){
    try { return Number(n).toLocaleString('en-US'); } catch(e){ return String(n); }
  }
  function points(smile, n){
    if(smile && typeof smile.formatPoints === 'function'){
      try { var o = smile.formatPoints(n); if(o) return String(o); } catch(e){}
    }
    return commas(n) + ' Club Credits';
  }

  /* Wait for Smile to attach. Capped at ~4s: long enough for a slow load,
     short enough that the shelf never sits there shimmering at someone. */
  function whenSmile(cb){
    var tries = 0;
    (function poll(){
      var S = window.SmileUI && window.SmileUI.smile;
      if(S){ WOFR.smile = true; log('smile found after ' + tries + ' polls'); return cb(S); }
      if(++tries > 27){ log('gave up waiting for smile'); return cb(null); }
      setTimeout(poll, 150);
    })();
  }

  function showBalance(smile){
    if(!elBal){ log('signed out per Liquid, nothing to fill'); return false; }
    var c = smile && smile.customer;
    if(!c){ log('no customer object'); return false; }
    if(typeof c.points_balance !== 'number'){
      log('customer present but points_balance is ' + typeof c.points_balance);
      WOFR.customerKeys = Object.keys(c).join(',');
      return false;
    }
    WOFR.customer = true; log('balance read: ' + c.points_balance);
    elNum.hidden = false;

    /* Member-since. Smile's created_at is the only source for it. */
    if(elSince && c.created_at){
      try {
        var d = new Date(c.created_at);
        if(!isNaN(d)){
          elSince.textContent = d.toLocaleDateString('en-US', { month:'short', year:'numeric' });
        }
      } catch(e){}
    }

    balance = c.points_balance;
    elNum.textContent = points(smile, balance);

    var line = '';
    if(c.delta_to_next_vip_tier_formatted){
      line = 'Earn ' + c.delta_to_next_vip_tier_formatted + ' to reach INSIDER.';
    } else if(c.delta_to_retain_vip_tier_formatted && c.next_vip_period_end_formatted){
      line = "You're an INSIDER. Earn " + c.delta_to_retain_vip_tier_formatted +
             ' more by ' + c.next_vip_period_end_formatted + ' to keep INSIDER next year.';
    } else if(c.delta_to_retain_vip_tier_formatted){
      line = "You're an INSIDER. Earn " + c.delta_to_retain_vip_tier_formatted + ' more to keep INSIDER.';
    }
    if(line && elTier){ elTier.textContent = line; elTier.hidden = false; }

    /* Insider meter, only when there is a real distance still to travel. */
    if(INSIDER_AT > 0 && elMeter && c.delta_to_next_vip_tier_formatted){
      var left = parseFloat(String(c.delta_to_next_vip_tier_formatted).replace(/[^0-9.]/g,''));
      if(isFinite(left) && left > 0 && left <= INSIDER_AT){
        var done = INSIDER_AT - left;
        elMFill.style.width = Math.max(2, Math.min(100, (done/INSIDER_AT)*100)) + '%';
        elMCap.textContent = commas(done) + ' of ' + commas(INSIDER_AT) + ' credits earned.';
        elMeter.hidden = false;
      }
    }

    return true;
  }

  function cardHTML(item){
    var r = item.reward || {}, price = item.points_price;
    var open = (balance !== null && typeof price === 'number' && balance >= price);

    var pic = r.image_url
      ? '<img class="wofr-card__pic" src="' + esc(r.image_url) + '" alt="" loading="lazy">'
      : '<span class="wofr-card__nopic" aria-hidden="true">' + esc(commas(price)) + '</span>';

    var val = (typeof r.value === 'number')
      ? '<span class="wofr-card__val">' + esc('$' + r.value.toFixed(2)) + ' value</span>' : '';

    var state = '';
    if(balance !== null && typeof price === 'number'){
      state = open ? 'Ready to redeem' : commas(price - balance) + ' more to go';
    }

    var pp = (item.id != null) ? ' data-pp="' + esc(item.id) + '"' : '';
    return '<li><a class="wofr-card' + (open ? ' wofr-card--open' : '') + '" href="' + REDEEM + '"' + pp + '>' +
      (open ? '<span class="wofr-card__flag">Yours</span>' : '') +
      pic +
      '<p class="wofr-card__name">' + esc(r.name || 'Reward') + '</p>' +
      '<p class="wofr-card__meta"><span class="wofr-card__pts">' + esc(commas(price)) + '</span>' + val + '</p>' +
      '<p class="wofr-card__state">' + esc(state) + '</p>' +
    '</a></li>';
  }

  /* THE RAIL IS SPACED BY POSITION ON THE SHELF, NOT BY CREDIT VALUE.
     Linear spacing is unusable here: with the top reward at 8,000 and seven of
     eight priced under 2,000, the ticks bunch into the left quarter (700 and 750
     land 7.5px apart on a 1200px rail) and three quarters of the rail is empty.
     Equal spacing gives every reward the same room, and the pin is INTERPOLATED
     inside whichever gap the balance actually falls in - so it still moves
     smoothly and still tells the truth about which reward is next.
     The left edge is zero credits, which is why tick i sits at (i+1)*seg. */
  /* Each tile opens ITS OWN reward rather than the generic redeem list, via
     Smile's points_product:{id} deep link. The href stays as the plain
     #smile-points-products anchor, so if openPanel is missing or the id is
     rejected the customer still lands somewhere sensible instead of nowhere.
     Delegated, so it survives the grid being re-rendered when a balance
     arrives late. */
  var wired = false;
  function wireDeepLinks(){
    if(wired || !elGrid) return;
    wired = true;
    elGrid.addEventListener('click', function(ev){
      var a = ev.target && ev.target.closest ? ev.target.closest('.wofr-card') : null;
      if(!a) return;
      var id = a.getAttribute('data-pp');
      if(!id) return;
      var S = window.SmileUI;
      if(!S || typeof S.openPanel !== 'function') return;   // let the href run
      try {
        S.openPanel({ deep_link: 'points_product:' + id });
        ev.preventDefault();
        log('opened reward ' + id);
      } catch(e){
        log('deep link failed, falling back: ' + e);        // href runs
      }
    });
  }

  /* The next reward they cannot afford yet, rendered as the act's lead. Stays
     hidden unless BOTH a real balance and a real next reward exist - never a
     placeholder, never a guess. */
  function drawNext(list){
    if(!elNext) return;
    if(balance === null){ elNext.hidden = true; return; }
    var next = null;
    for(var i=0;i<list.length;i++){
      if((list[i].points_price || 0) > balance){ next = list[i]; break; }
    }
    if(!next || !next.reward){ elNext.hidden = true; return; }   // they have it all
    var r = next.reward;
    if(elNextK) elNextK.textContent =
      'You are ' + commas(next.points_price - balance) + ' Club Credits away';
    if(elNextN) elNextN.textContent = r.name || 'your next reward';
    if(elNextM) elNextM.textContent =
      commas(next.points_price) + ' Club Credits' +
      (typeof r.value === 'number' ? '  \u00b7  $' + r.value.toFixed(2) + ' value' : '');
    if(elNextPic){
      if(r.image_url){ elNextPic.src = r.image_url; elNextPic.hidden = false; }
      else elNextPic.hidden = true;
    }
    elNext.hidden = false;
    log('next unlock: ' + r.name);
  }

  function drawRail(list){
    if(!elRail || !elFill || !elPin || !elTicks) return;   // rail retired from the markup
    if(balance === null || !list.length) return;

    var n = list.length, seg = 100 / n;
    var prices = list.map(function(it){ return it.points_price || 0; });

    var pct;
    if(balance <= prices[0]){
      pct = prices[0] ? (balance / prices[0]) * seg : 0;
    } else if(balance >= prices[n-1]){
      pct = 100;
    } else {
      pct = 100;
      for(var i = 0; i < n - 1; i++){
        if(balance >= prices[i] && balance < prices[i+1]){
          var span = prices[i+1] - prices[i];
          pct = (i+1) * seg + (span ? (balance - prices[i]) / span * seg : 0);
          break;
        }
      }
    }
    pct = Math.max(0, Math.min(100, pct));

    elFill.style.width = pct + '%';
    elPin.style.left = pct + '%';
    elPinNum.textContent = commas(balance);

    elTicks.innerHTML = list.map(function(it, i){
      var p = (i+1) * seg;
      /* mark the ones already passed so they can be dimmed */
      var got = (it.points_price || 0) <= balance ? ' is-got' : '';
      return '<span class="wofr-rail__tick' + got + '" style="left:' + p + '%">' +
             '<b>' + esc(commas(it.points_price)) + '</b></span>';
    }).join('');
    elRail.hidden = false;
  }

  function showLadder(list){
    if(!list || !list.length){ shelfDead('ladder returned nothing'); return; }

    list = list.slice().sort(function(a,b){
      return (a.points_price || 0) - (b.points_price || 0);
    });

    elGrid.innerHTML = list.map(cardHTML).join('');
    if(elDead) elDead.hidden = true;
    wireDeepLinks();
    drawNext(list);
    drawRail(list);
    realign();                 // the grid just changed the page height

    if(balance !== null){
      var next = null;
      for(var i=0;i<list.length;i++){
        if(list[i].points_price > balance){ next = list[i]; break; }
      }
      /* the hero row above says this now */
    } else if(elOff){
      elOff.hidden = false;
    }
  }

  var LIST = null;   // the ladder, kept so it can be re-rendered if a balance lands later

  /* The ladder is public catalogue data. It has NEVER needed the customer, and
     chaining it behind one is what let a pending promise take the shelf down. */
  function loadLadder(smile){
    if(typeof smile.fetchAllPointsProducts !== 'function'){
      shelfDead('no fetchAllPointsProducts method'); return;
    }
    try {
      smile.fetchAllPointsProducts()
        .then(function(list){
          WOFR.ladder = (list && list.length) || 0;
          log('ladder returned ' + WOFR.ladder + ' rewards');
          LIST = list;
          showLadder(list);
        })
        .catch(function(e){ shelfDead('ladder fetch failed: ' + (e && e.message)); });
    } catch(e){ shelfDead('ladder fetch threw: ' + e); }
  }

  /* customerReady() resolves on success and rejects on error, but a visitor
     Smile never identifies leaves it PENDING FOREVER - no resolve, no reject.
     So race it against the customer object simply appearing, and against a
     hard timeout, and make sure nothing else waits on the outcome. */
  function loadCustomer(smile){
    var settled = false;

    function got(where){
      if(settled) return; settled = true;
      log('customer via ' + where);
      if(showBalance(smile) && LIST) showLadder(LIST);   // re-render with affordability
    }
    function gaveUp(why){
      if(settled) return; settled = true;
      log('no balance: ' + why);
    }

    if(typeof smile.customerReady === 'function'){
      try {
        Promise.resolve(smile.customerReady())
          .then(function(){ got('customerReady'); })
          .catch(function(e){ gaveUp('customerReady rejected: ' + (e && e.message)); });
      } catch(e){ gaveUp('customerReady threw: ' + e); }
    } else {
      log('no customerReady method');
    }

    var n = 0;
    (function poll(){
      if(settled) return;
      var c = smile.customer;
      if(c && typeof c.points_balance === 'number') return got('smile.customer appeared');
      if(++n > 40) return gaveUp('Smile never identified this visitor (6s)');
      setTimeout(poll, 150);
    })();
  }

  /* ============================================================
     GLOBO FORM PREFILL
     The claim form is built by Globo's script, asynchronously, and only once
     the <details> is opened - so we watch for the field rather than looking
     for it at boot.

     ***THE TRAP: GLOBO'S FORM IS FRAMEWORK-RENDERED. Assigning input.value
     updates what you SEE but not the framework's internal model, so the field
     submits EMPTY.*** The value has to go through the native property setter
     and then fire input+change so the framework records it.
     ============================================================ */
  var EMAIL  = root.getAttribute('data-email')  || '';
  var DOG    = root.getAttribute('data-dog')    || '';
  var CLINIC = root.getAttribute('data-clinic') || '';

  /* Legacy records hold a PHONE NUMBER in the clinic metafield, from an old
     write bug. Filling that into "Clinic/Hospital Name" would be worse than
     leaving it blank, so anything without letters is rejected. */
  function looksLikeAName(v){
    return /[a-z]/i.test(v) && v.replace(/[^0-9]/g,'').length < 7;
  }

  function setValue(el, v){
    try {
      var d = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value');
      if(d && d.set) d.set.call(el, v); else el.value = v;
      el.dispatchEvent(new Event('input',  { bubbles:true }));
      el.dispatchEvent(new Event('change', { bubbles:true }));
      return true;
    } catch(e){ log('prefill setValue failed: ' + e); return false; }
  }

  /* Find a field by its own attributes first, then by what its label says.
     Globo regenerates field ids when a form is edited, so the label text is the
     only stable handle. */
  function findField(box, spec){
    var el = spec.sel ? box.querySelector(spec.sel) : null;
    if(el) return el;
    var ins = box.querySelectorAll('input[type="text"], input:not([type]), input[type="email"]');
    for(var i=0;i<ins.length;i++){
      if(spec.name && spec.name.test(ins[i].name || '')) return ins[i];
    }
    for(var j=0;j<ins.length;j++){
      var wrap = ins[j].closest('.globo-form-control') || ins[j].parentElement;
      var txt  = wrap ? (wrap.textContent || '') : '';
      if(spec.label.test(txt) && !(spec.not && spec.not.test(txt))) return ins[j];
    }
    return null;
  }

  /* email is IDENTITY, so it locks. clinic and dog are DEFAULTS - the visit may
     have been at a different clinic, and the household may have several dogs -
     so they prefill and stay editable. */
  var FIELDS = [
    { key:'email',  value:function(){ return EMAIL; },  lock:true,
      sel:'input[type="email"]', name:/e-?mail/i, label:/e-?mail/i },
    { key:'clinic', value:function(){ return looksLikeAName(CLINIC) ? CLINIC : ''; }, lock:false,
      name:/clinic|hospital|practice|vet/i, label:/clinic|hospital|practice/i },
    { key:'dog',    value:function(){ return DOG; }, lock:false,
      name:/dog|pet/i, label:/dog|pet/i, not:/clinic|hospital|practice/i }
  ];

  function prefill(){
    var box = root.querySelector('.wofr-form');
    if(!box) return true;

    var wanted = 0, done = 0;
    for(var i=0;i<FIELDS.length;i++){
      var f = FIELDS[i], v = f.value();
      if(!v) continue;
      wanted++;
      var el = findField(box, f);
      if(!el){ continue; }
      done++;
      if(el.value) continue;                 // never overwrite something already there
      if(setValue(el, v)){
        if(f.lock){
          el.setAttribute('readonly','readonly');
          el.classList.add('wofr-locked');
        }
        log('prefilled ' + f.key);
      }
    }
    if(!wanted) return true;                 // nothing to fill, stop watching
    return done === wanted;                  // keep watching until every field exists
  }

  (function watchForm(){
    var box = root.querySelector('.wofr-form');
    if(!box || (!EMAIL && !DOG && !CLINIC)) return;
    if(prefill()) return;

    var tries = 0;
    var obs = new MutationObserver(function(){
      if(prefill()) obs.disconnect();
    });
    obs.observe(box, { childList:true, subtree:true });

    /* Belt and braces: a details that is opened later, and a hard stop so the
       observer never lives forever on a page where the form never builds. */
    var det = root.querySelector('.wofr-claim');
    if(det) det.addEventListener('toggle', function(){ prefill(); });
    (function poll(){
      if(++tries > 40) return obs.disconnect();
      if(prefill()) return obs.disconnect();
      setTimeout(poll, 250);
    })();
  })();


  /* ============================================================
     SMILE PANEL RESKIN
     The panel renders in a JS-created, src-less iframe, which runs on
     about:blank and therefore inherits THIS origin - so its document is
     writable and we can append a stylesheet to it. Confirmed by actually
     appending and removing a style node before building this.

     ***THIS IS SMILE'S OWN MARKUP AND IT IS UNVERSIONED.*** Every step is
     wrapped so that a rename, a throw, or a missing node means SMILE'S
     DEFAULT PANEL, never a half-skinned one. `data-skin="off"` on the
     section disables it with nothing to undo.

     Fonts: a face loaded by the theme is NOT available inside the frame, and
     the theme stylesheet is cross-origin so its @font-face rules cannot be
     read. We try anyway and fall back to weight/caps/letter-spacing.
     ============================================================ */
  /* ---- landing on an anchor -------------------------------------------
     The shelf renders ASYNCHRONOUSLY. A browser that jumps to #tiers on load
     lands correctly, then eight reward cards appear ABOVE it, everything below
     shifts down, and the anchor is no longer where it scrolled to. So we
     re-align after each render that changes the page's height.
     Guarded hard: only for our own anchors, only in the first few seconds, and
     it stops the instant the visitor scrolls themselves - a page that yanks
     itself while you are reading is worse than a slightly wrong landing. */
  var ANCHORS = ['wellness','shelf','tiers','faq'];
  var alignFor = null, userScrolled = false;

  function hashTarget(){
    var id = (location.hash || '').slice(1).toLowerCase();
    return ANCHORS.indexOf(id) === -1 ? null : document.getElementById(id);
  }
  function armAlign(){
    if(!hashTarget()) return;
    alignFor = Date.now() + 4000;
    realign();
  }
  function realign(){
    if(userScrolled || !alignFor || Date.now() > alignFor) return;
    var el = hashTarget();
    if(el && el.scrollIntoView) { try { el.scrollIntoView(true); } catch(e){} }
  }
  try {
    ['wheel','touchmove','keydown'].forEach(function(ev){
      window.addEventListener(ev, function(){ userScrolled = true; },
                              { passive:true, once:true });
    });
    window.addEventListener('hashchange', function(){
      userScrolled = false; armAlign();
    });
    armAlign();
  } catch(e){}

  /* ---- the CLUB stamp ---------------------------------------------------
     Fires once when the mark comes into view. The hiding class is added HERE
     rather than in the stylesheet, so a visitor with no JS, an old browser, or
     reduced motion always sees the tab - it can never be left invisible by a
     failure. */
  (function stamp(){
    var mark = root.querySelector('.wofr-mark');
    if(!mark) return;
    var reduce = false;
    try {
      reduce = window.matchMedia &&
               window.matchMedia('(prefers-reduced-motion:reduce)').matches;
    } catch(e){}
    if(reduce || !('IntersectionObserver' in window)) return;   // tab just sits there

    mark.classList.add('wofr-mark--anim');
    var fired = false;
    function go(){
      if(fired) return; fired = true;
      mark.classList.add('is-stamped');
    }
    try {
      var io = new IntersectionObserver(function(es){
        for(var i=0;i<es.length;i++){
          if(es[i].isIntersecting){ go(); io.disconnect(); }
        }
      }, { threshold:.35 });
      io.observe(mark);
    } catch(e){ go(); }        // anything unexpected: show it rather than hide it
    /* belt and braces - if the observer never fires for any reason, the tab
       must not stay invisible */
    setTimeout(go, 2500);
  })();

  var SKIN_NAME = (root.getAttribute('data-skin') || 'off').toLowerCase();
  var SKIN_ON = SKIN_NAME !== 'off' && SKIN_NAME !== '';

  /* Copy any @font-face rules we are actually allowed to read. */
  function harvestFaces(){
    var out = '';
    try {
      for(var i=0; i<document.styleSheets.length; i++){
        var rules;
        try { rules = document.styleSheets[i].cssRules; } catch(e){ continue; }  // cross-origin
        if(!rules) continue;
        for(var j=0; j<rules.length; j++){
          if(rules[j].type === 5 /* CSSFontFaceRule */) out += rules[j].cssText + '\n';
        }
      }
    } catch(e){}
    return out;
  }

  /* ---- BASE: structure, shared by every variant --------------------------
     Two real defects fixed here, both visible in the shipped v1:
     1. `.card-list-item` sits INSIDE `.card-list-item-container`. Styling both
        gave every row two borders. Only the inner one is a card now.
     2. The rows are a flex line, and nothing told the text column it could
        shrink - so the button pushed "700 Club Credits" onto two lines. The
        text wrapper is now `min-width:0`, the controls are `flex:0 0 auto`. */
  function skinBase(){
    return [
      '*{box-sizing:border-box;}',
      '.card-list-item-container{',
      '  background:none!important;border:0!important;box-shadow:none!important;',
      '  padding:0!important;margin:0 0 10px!important;}',
      '.card-list-item{',
      '  box-shadow:none!important;overflow:hidden!important;',
      '  border-bottom:0!important;transition:none!important;}',
      /* Smile draws a hairline between rows from more than one place; belt and
         braces, or it survives and crosses the card's own shadow. */
      '.card-list-container > *,.card-list-item-container > *,',
      '.panel-card-container > *,.rewards-summary-card > *{',
      '  border-top:0!important;border-bottom:0!important;}',
      '.card-list-container hr,.card-list-item + hr,.line{display:none!important;}',
      /* ***THE DIVIDER IS A PSEUDO-ELEMENT, NOT A BORDER.*** Measured on the live
         panel: .card-list-item-container::after is a 1px #e6e6e6 bar. Every
         border-top/border-bottom reset missed it because there is no border to
         reset. */
      '.card-list-item-container::after,.card-list-item-container::before,',
      '.card-list-item::after{display:none!important;content:none!important;}',
      /* ***THE HOME VIEW WRAPS CARD GROUPS AGAIN.*** Measured off the live panel:
         .panel-card-container paints its OWN white box, 10px radius, 16px 12px
         padding - so every card inside it ends up in a second frame, and two
         cards sharing one wrapper collide their offset shadows. Neutralised
         here, in the BASE, so it can never come back for one variant only. */
      '.panel-card-container,.rewards-summary-card,.home-view-container{',
      '  background:none!important;border:0!important;border-radius:0!important;',
      '  padding:0!important;box-shadow:none!important;}',
      '.panel-card-container{margin:0 0 14px!important;}',
      /* ***THE 60px BLACK STRIP IS `.panel-fixed-header`, a bar whose only job is
         to hold the close button.*** Taking it out of flow floats the button over
         the banner and reclaims the whole 60px. ***THE TRADE, ACCEPTED KNOWINGLY:
         it no longer sticks, so the X scrolls away on a long list*** - the back
         chevron and a tap outside still close the panel. Revert by deleting
         these three rules. */
      '.panel-fixed-header{',
      '  position:absolute!important;top:0!important;left:0!important;right:0!important;',
      '  z-index:6!important;background:none!important;',
      '  min-height:0!important;padding:6px 8px!important;}',
      /* a whisper of ink under the button so it stays readable wherever the
         banner artwork happens to be light */
      '.panel-fixed-header::before{',
      '  content:""!important;position:absolute!important;inset:0!important;',
      '  background:linear-gradient(rgba(46,44,43,.45),rgba(46,44,43,0))!important;',
      '  pointer-events:none!important;z-index:-1!important;}',
      '.panel-header-container{min-height:0!important;}',
      /* .banner-image renders 228px tall while .banner-content needs only 137,
         so ~91px of it is empty. Cover-crop it against the content height
         instead of letting the image's own proportions set the box. */
      '.banner-image{',
      '  min-height:0!important;height:auto!important;',
      '  background-size:cover!important;background-position:center right!important;}',
      '.panel-card-container > *,.rewards-summary-card > *{border-bottom:0!important;}',
      '.card-list-item-content,.card-list-item .d-flex{',
      '  display:flex!important;align-items:center!important;gap:12px!important;}',
      '.card-list-item-content{padding:12px 14px!important;}',
      /* the text column is the only thing allowed to shrink */
      '.list-item-text-wrapper,.flex-truncate{flex:1 1 auto!important;min-width:0!important;}',
      /* uppercase costs roughly a tenth of the width, which is what pushed
         "FREE SHAMPOO" onto two lines - 14px with no extra tracking fits. */
      '.list-item-title{',
      '  font-size:14px!important;line-height:1.2!important;margin:0 0 2px!important;',
      '  font-weight:800!important;letter-spacing:0!important;',
      '  text-transform:uppercase!important;}',
      '.list-item-subtitle{',
      '  font-size:12.5px!important;line-height:1.3!important;',
      '  white-space:nowrap!important;overflow:hidden!important;text-overflow:ellipsis!important;}',
      '.list-item-image{',
      '  width:50px!important;height:50px!important;flex:0 0 50px!important;',
      '  object-fit:contain!important;border-radius:10px!important;padding:5px!important;}',
      /* controls keep their own width instead of squeezing the words */
      '.btn,.btn-primary,.btn-sm,.customer-points-products-button{',
      '  flex:0 0 auto!important;white-space:nowrap!important;',
      '  padding:8px 12px!important;font-size:11.5px!important;line-height:1!important;',
      '  border:0!important;font-weight:800!important;',
      '  letter-spacing:.07em!important;text-transform:uppercase!important;}',
      '.custom-progress-meter{flex:0 0 auto!important;}',
      '.list-title,.heading{',
      '  font-weight:800!important;letter-spacing:.12em!important;',
      '  text-transform:uppercase!important;font-size:12px!important;}',
      '.close-btn,.chevron-btn,.panel-header-icon{opacity:1!important;}'
    ].join('\n');
  }

  /* ***THE CLOSE AND BACK BUTTONS ARE EMPTY ELEMENTS.*** Read off the live
     panel: `<button aria-label="Close" class="close-btn panel-header-icon">`
     with NO child node, and a computed `color` that was already cream. So the
     glyph is painted by CSS on the button itself - a background image or a
     pseudo-element - and it does not use currentColor, which is why setting
     `color` did nothing and why every `svg`/`path` selector matched nothing.
     Filtering the BUTTON catches a background image and a pseudo-element
     alike, without needing to know which one it is. */
  function icons(dark){
    var fg   = dark ? '#fdf8ec' : '#2e2c2b';
    var mute = dark ? 'rgba(253,248,236,.74)' : 'rgba(46,44,43,.72)';
    return [
      /* the empty icon buttons - see the note above */
      '.close-btn,.chevron-btn,.panel-header-icon{',
      '  filter:' + (dark ? 'brightness(0) invert(1)' : 'brightness(0)') + '!important;',
      '  opacity:1!important;}',
      /* ***`.caption` IS USED TWICE: the muted subtitle on the white cards AND the
         label on the dark banner. Colouring it once for the cards painted the
         banner label dark-on-dark. These header-scoped rules must come after,
         and be more specific than, the card rule. Smile will not accept an
         empty caption, so this is the only way to make it readable.*** */
      '.panel-header-container .caption,.background-gradient .caption,',
      '.banner-content .caption,.compact-banner .caption{color:' + mute + '!important;}',
      '.panel-header-container .display,.background-gradient .display,',
      '.banner-content .display,.panel-header-container .heading{color:' + fg + '!important;}',
      '.panel-header-container .tag,.background-gradient .tag,.banner-content .tag{',
      '  background:' + (dark ? '#ffd91f' : '#2e2c2b') + '!important;',
      '  color:' + (dark ? '#2e2c2b' : '#ffd91f') + '!important;}'
    ].join('\n');
  }

  /* ---- VARIANTS: colour and card treatment only -------------------------- */
  var SKINS = {

    /* Cream field, white cards, ink hairline. Closest to the page's shelf. */
    paper: [
      '.panel-wrapper,.panel-container,.main-panel-container,.panel-subview,',
      '.card-list-container{background:#fdf8ec!important;}',
      '.background-gradient,.panel-fixed-header,.panel-expanded-header,',
      '.panel-header-container{background:#2e2c2b!important;}',
      '.banner-content,.compact-banner,.header-content,.header-primary,',
      '.header-secondary,.close-btn,.chevron-btn,.panel-header-icon{color:#fdf8ec!important;}',
      icons(true),
      '.card-list-item{background:#fff!important;border:2px solid rgba(46,44,43,.16)!important;',
      '  border-radius:14px!important;}',
      '.list-item-image{background:#fdf8ec!important;}',
      '.list-item-title,.list-title,.heading{color:#2e2c2b!important;}',
      '.list-item-subtitle,.caption,.text-muted{color:rgba(46,44,43,.60)!important;}',
      '.btn,.btn-primary,.btn-sm,.customer-points-products-button{',
      '  background:#ffd91f!important;color:#2e2c2b!important;border-radius:8px!important;}',
      '.custom-progress-meter{color:#ffd91f!important;}',
      '.tag{background:#2e2c2b!important;color:#ffd91f!important;border-radius:6px!important;}'
    ].join('\n'),

    /* Dark. Continuous with the ink header, and the same object as the
       membership card and the Wellness panel on the page. */
    ink: [
      '.panel-wrapper,.panel-container,.main-panel-container,.panel-subview,',
      '.card-list-container{background:#2e2c2b!important;}',
      '.background-gradient,.panel-fixed-header,.panel-expanded-header,',
      '.panel-header-container{background:#2e2c2b!important;',
      '  border-bottom:2px solid rgba(253,248,236,.16)!important;}',
      '.banner-content,.compact-banner,.header-content,.header-primary,',
      '.header-secondary,.close-btn,.chevron-btn,.panel-header-icon{color:#fdf8ec!important;}',
      icons(true),
      '.card-list-item{background:rgba(253,248,236,.06)!important;',
      '  border:2px solid rgba(253,248,236,.20)!important;border-radius:14px!important;}',
      '.list-item-image{background:#fdf8ec!important;}',
      '.list-item-title{color:#fdf8ec!important;}',
      '.list-title,.heading{color:rgba(253,248,236,.62)!important;}',
      '.list-item-subtitle,.caption,.text-muted{color:rgba(253,248,236,.58)!important;}',
      '.btn,.btn-primary,.btn-sm,.customer-points-products-button{',
      '  background:#ffd91f!important;color:#2e2c2b!important;border-radius:8px!important;}',
      '.custom-progress-meter{color:#ffd91f!important;}',
      '.tag{background:#ffd91f!important;color:#2e2c2b!important;border-radius:6px!important;}'
    ].join('\n'),

    /* The page's own card language: 2px ink border with a hard yellow offset,
       exactly like an affordable tile on the shelf. */
    poster: [
      '.panel-wrapper,.panel-container,.main-panel-container,.panel-subview,',
      '.card-list-container{background:#fdf8ec!important;}',
      /* The offset shadow needs 6px MORE than the card's own width. The list
         has 16px of padding, so the card is pulled in 8px rather than the
         shadow being allowed to run off the panel edge. */
      '.card-list-item{margin-right:8px!important;}',
      '.background-gradient,.panel-fixed-header,.panel-expanded-header,',
      '.panel-header-container{background:#2e2c2b!important;}',
      '.banner-content,.compact-banner,.header-content,.header-primary,',
      '.header-secondary,.close-btn,.chevron-btn,.panel-header-icon{color:#fdf8ec!important;}',
      icons(true),
      /* ***overflow stays HIDDEN on the card itself.*** An element's own
         box-shadow is never clipped by its own overflow - only by an ANCESTOR's -
         so opening the card up gained nothing and let a square-cornered white
         child poke out past the rounded ink border. The ancestors below are the
         ones that actually needed opening. */
      '.card-list-item{background:#fff!important;border:2px solid #2e2c2b!important;',
      '  border-radius:14px!important;box-shadow:6px 6px 0 #ffd91f!important;',
      '  overflow:hidden!important;}',
      '.card-list-item-container{margin:0 0 18px!important;overflow:visible!important;}',
      '.card-list-container{overflow:visible!important;}',
      '.list-item-image{background:#fdf8ec!important;}',
      '.list-item-title,.list-title,.heading{color:#2e2c2b!important;}',
      '.list-item-subtitle,.caption,.text-muted{color:rgba(46,44,43,.60)!important;}',
      '.btn,.btn-primary,.btn-sm,.customer-points-products-button{',
      '  background:#2e2c2b!important;color:#ffd91f!important;border-radius:8px!important;}',
      '.custom-progress-meter{color:#2e2c2b!important;}',
      '.tag{background:#ffd91f!important;color:#2e2c2b!important;border-radius:6px!important;}'
    ].join('\n'),

    /* Full yellow field, ink cards. The loudest, and the closest to the hero. */
    yellow: [
      '.panel-wrapper,.panel-container,.main-panel-container,.panel-subview,',
      '.card-list-container{background:#ffd91f!important;}',
      '.background-gradient,.panel-fixed-header,.panel-expanded-header,',
      '.panel-header-container{background:#2e2c2b!important;}',
      '.banner-content,.compact-banner,.header-content,.header-primary,',
      '.header-secondary,.close-btn,.chevron-btn,.panel-header-icon{color:#ffd91f!important;}',
      icons(true),
      '.card-list-item{background:#2e2c2b!important;border:0!important;',
      '  border-radius:14px!important;}',
      '.list-item-image{background:#fdf8ec!important;}',
      '.list-item-title{color:#fdf8ec!important;}',
      '.list-title,.heading{color:rgba(46,44,43,.72)!important;}',
      '.list-item-subtitle,.caption,.text-muted{color:rgba(253,248,236,.62)!important;}',
      '.btn,.btn-primary,.btn-sm,.customer-points-products-button{',
      '  background:#ffd91f!important;color:#2e2c2b!important;border-radius:8px!important;}',
      '.custom-progress-meter{color:#ffd91f!important;}',
      '.tag{background:#ffd91f!important;color:#2e2c2b!important;border-radius:6px!important;}'
    ].join('\n'),

    /* No card chrome at all. Rows on a rule, bigger art, the button demoted to
       a text link. Editorial, and the quietest of the five. */
    shelf: [
      '.panel-wrapper,.panel-container,.main-panel-container,.panel-subview,',
      '.card-list-container{background:#fdf8ec!important;}',
      '.background-gradient,.panel-fixed-header,.panel-expanded-header,',
      '.panel-header-container{background:#ffd91f!important;}',
      '.banner-content,.compact-banner,.header-content,.header-primary,',
      '.header-secondary,.close-btn,.chevron-btn,.panel-header-icon{color:#2e2c2b!important;}',
      icons(false),
      '.card-list-item-container{margin:0!important;}',
      '.card-list-item{background:none!important;border:0!important;border-radius:0!important;',
      '  border-bottom:2px solid rgba(46,44,43,.16)!important;}',
      '.card-list-item-container:last-child .card-list-item{border-bottom:0!important;}',
      '.card-list-item-content{padding:16px 4px!important;}',
      '.list-item-image{width:64px!important;height:64px!important;flex:0 0 64px!important;',
      '  background:none!important;padding:0!important;border-radius:12px!important;}',
      '.list-item-title,.list-title,.heading{color:#2e2c2b!important;}',
      '.list-item-subtitle,.caption,.text-muted{color:rgba(46,44,43,.60)!important;}',
      '.btn,.btn-primary,.btn-sm,.customer-points-products-button{',
      '  background:none!important;color:#2e2c2b!important;padding:6px 0!important;',
      '  border-bottom:2px solid #ffd91f!important;border-radius:0!important;}',
      '.custom-progress-meter{color:#2e2c2b!important;}',
      '.tag{background:#2e2c2b!important;color:#ffd91f!important;border-radius:6px!important;}'
    ].join('\n')
  };

  function skinCSS(){
    var v = SKINS[SKIN_NAME] || SKINS.paper;
    /* The recaptcha badge is deliberately untouched - hiding it breaks
       Google's terms. */
    return harvestFaces() + skinBase() + '\n' + v;
  }

  /* Is this the Smile panel frame, rather than some other src-less iframe? */
  function panelDoc(fr){
    var d;
    try { d = fr.contentDocument; } catch(e){ return null; }
    if(!d || !d.body) return null;
    return d.querySelector('.panel-wrapper,.frame-root,.card-list-container') ? d : null;
  }

  function paintPanel(){
    if(!SKIN_ON) return;
    try { paintPanelInner(); } catch(e){ /* never let the watcher throw */ }
  }

  function paintPanelInner(){
    if(!document || !document.querySelectorAll) return;
    var frames = document.querySelectorAll('iframe');
    for(var i=0; i<frames.length; i++){
      if(frames[i].src) continue;
      var d = panelDoc(frames[i]);
      if(!d) continue;
      if(d.getElementById('wofr-skin')) continue;      // already done
      try {
        var st = d.createElement('style');
        st.id = 'wofr-skin';
        st.textContent = skinCSS();
        (d.head || d.documentElement).appendChild(st);
        log('smile panel skinned');
      } catch(e){ log('panel skin failed: ' + e); }     // Smile's default stands
    }
  }

  if(SKIN_ON){
    try {
      /* The frame is created when the panel first opens, and Smile may rebuild
         its contents, so watch for both rather than painting once. */
      var mo = new MutationObserver(function(){
        try { paintPanel(); } catch(e){}
      });
      mo.observe(document.documentElement, { childList:true, subtree:true });
      document.addEventListener('click', function(){
        setTimeout(function(){ try { paintPanel(); } catch(e){} }, 260);
      }, true);
      paintPanel();
    } catch(e){ log('panel watcher failed: ' + e); }
  }

  whenSmile(function(smile){
    if(!smile){ shelfDead('smile never attached'); if(elOff) elOff.hidden = false; return; }
    loadLadder(smile);     // independent, and first
    loadCustomer(smile);
  });
})();